export default {
    props: {
        valueAxisValueAxisItemAxisCrossingValue: {
            type: Object | Date | Array,
            kComposite: 'valueAxis.valueAxisItem.axisCrossingValue'
        }, 
        valueAxisValueAxisItemColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.color'
        }, 
        valueAxisValueAxisItemLabelsBackground: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.labels.background'
        }, 
        valueAxisValueAxisItemLabelsBorderColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.labels.border.color'
        }, 
        valueAxisValueAxisItemLabelsBorderDashType: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.labels.border.dashType'
        }, 
        valueAxisValueAxisItemLabelsBorderWidth: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.labels.border.width'
        }, 
        valueAxisValueAxisItemLabelsColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.labels.color'
        }, 
        valueAxisValueAxisItemLabelsFont: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.labels.font'
        }, 
        valueAxisValueAxisItemLabelsFormat: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.labels.format'
        }, 
        valueAxisValueAxisItemLabelsMargin: {
            type: Number | Object,
            kComposite: 'valueAxis.valueAxisItem.labels.margin'
        }, 
        valueAxisValueAxisItemLabelsMirror: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.labels.mirror'
        }, 
        valueAxisValueAxisItemLabelsPadding: {
            type: Number | Object,
            kComposite: 'valueAxis.valueAxisItem.labels.padding'
        }, 
        valueAxisValueAxisItemLabelsRotation: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.labels.rotation'
        }, 
        valueAxisValueAxisItemLabelsSkip: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.labels.skip'
        }, 
        valueAxisValueAxisItemLabelsStep: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.labels.step'
        }, 
        valueAxisValueAxisItemLabelsTemplate: {
            type: String | Function,
            kComposite: 'valueAxis.valueAxisItem.labels.template'
        }, 
        valueAxisValueAxisItemLabelsVisible: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.labels.visible'
        }, 
        valueAxisValueAxisItemLineColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.line.color'
        }, 
        valueAxisValueAxisItemLineDashType: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.line.dashType'
        }, 
        valueAxisValueAxisItemLineVisible: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.line.visible'
        }, 
        valueAxisValueAxisItemLineWidth: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.line.width'
        }, 
        valueAxisValueAxisItemMajorGridLinesColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.color'
        }, 
        valueAxisValueAxisItemMajorGridLinesVisible: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.visible'
        }, 
        valueAxisValueAxisItemMajorGridLinesWidth: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.width'
        }, 
        valueAxisValueAxisItemMajorGridLinesStep: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.step'
        }, 
        valueAxisValueAxisItemMajorGridLinesSkip: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.majorGridLines.skip'
        }, 
        valueAxisValueAxisItemMajorTicksSize: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.size'
        }, 
        valueAxisValueAxisItemMajorTicksVisible: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.visible'
        }, 
        valueAxisValueAxisItemMajorTicksColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.color'
        }, 
        valueAxisValueAxisItemMajorTicksWidth: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.width'
        }, 
        valueAxisValueAxisItemMajorTicksStep: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.step'
        }, 
        valueAxisValueAxisItemMajorTicksSkip: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.majorTicks.skip'
        }, 
        valueAxisValueAxisItemMajorUnit: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.majorUnit'
        }, 
        valueAxisValueAxisItemMax: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.max'
        }, 
        valueAxisValueAxisItemMin: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.min'
        }, 
        valueAxisValueAxisItemMinorGridLinesColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.color'
        }, 
        valueAxisValueAxisItemMinorGridLinesDashType: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.dashType'
        }, 
        valueAxisValueAxisItemMinorGridLinesVisible: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.visible'
        }, 
        valueAxisValueAxisItemMinorGridLinesWidth: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.width'
        }, 
        valueAxisValueAxisItemMinorGridLinesStep: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.step'
        }, 
        valueAxisValueAxisItemMinorGridLinesSkip: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.minorGridLines.skip'
        }, 
        valueAxisValueAxisItemMinorTicksSize: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.size'
        }, 
        valueAxisValueAxisItemMinorTicksColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.color'
        }, 
        valueAxisValueAxisItemMinorTicksWidth: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.width'
        }, 
        valueAxisValueAxisItemMinorTicksVisible: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.visible'
        }, 
        valueAxisValueAxisItemMinorTicksStep: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.step'
        }, 
        valueAxisValueAxisItemMinorTicksSkip: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.minorTicks.skip'
        }, 
        valueAxisValueAxisItemMinorUnit: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.minorUnit'
        }, 
        valueAxisValueAxisItemName: {
            type: Object,
            kComposite: 'valueAxis.valueAxisItem.name'
        }, 
        valueAxisValueAxisItemNarrowRange: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.narrowRange'
        }, 
        valueAxisValueAxisItemPlotBands: {
            type: Array,
            kComposite: 'valueAxis.valueAxisItem.plotBands'
        },         valueAxisValueAxisItemReverse: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.reverse'
        }, 
        valueAxisValueAxisItemTitleBackground: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.title.background'
        }, 
        valueAxisValueAxisItemTitleBorderColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.title.border.color'
        }, 
        valueAxisValueAxisItemTitleBorderDashType: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.title.border.dashType'
        }, 
        valueAxisValueAxisItemTitleBorderWidth: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.title.border.width'
        }, 
        valueAxisValueAxisItemTitleColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.title.color'
        }, 
        valueAxisValueAxisItemTitleFont: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.title.font'
        }, 
        valueAxisValueAxisItemTitleMargin: {
            type: Number | Object,
            kComposite: 'valueAxis.valueAxisItem.title.margin'
        }, 
        valueAxisValueAxisItemTitlePadding: {
            type: Number | Object,
            kComposite: 'valueAxis.valueAxisItem.title.padding'
        }, 
        valueAxisValueAxisItemTitlePosition: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.title.position'
        }, 
        valueAxisValueAxisItemTitleRotation: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.title.rotation'
        }, 
        valueAxisValueAxisItemTitleText: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.title.text'
        }, 
        valueAxisValueAxisItemTitleVisible: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.title.visible'
        }, 
        valueAxisValueAxisItemVisible: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.visible'
        }, 
        valueAxisValueAxisItemCrosshairColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.crosshair.color'
        }, 
        valueAxisValueAxisItemCrosshairWidth: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.crosshair.width'
        }, 
        valueAxisValueAxisItemCrosshairOpacity: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.crosshair.opacity'
        }, 
        valueAxisValueAxisItemCrosshairDashType: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.crosshair.dashType'
        }, 
        valueAxisValueAxisItemCrosshairVisible: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.crosshair.visible'
        }, 
        valueAxisValueAxisItemCrosshairTooltipBackground: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.background'
        }, 
        valueAxisValueAxisItemCrosshairTooltipBorderColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.border.color'
        }, 
        valueAxisValueAxisItemCrosshairTooltipBorderWidth: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.border.width'
        }, 
        valueAxisValueAxisItemCrosshairTooltipColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.color'
        }, 
        valueAxisValueAxisItemCrosshairTooltipFont: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.font'
        }, 
        valueAxisValueAxisItemCrosshairTooltipFormat: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.format'
        }, 
        valueAxisValueAxisItemCrosshairTooltipPadding: {
            type: Number | Object,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.padding'
        }, 
        valueAxisValueAxisItemCrosshairTooltipTemplate: {
            type: String | Function,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.template'
        }, 
        valueAxisValueAxisItemCrosshairTooltipVisible: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.crosshair.tooltip.visible'
        }, 
        valueAxisValueAxisItemNotesPosition: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.notes.position'
        }, 
        valueAxisValueAxisItemNotesIconBackground: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.background'
        }, 
        valueAxisValueAxisItemNotesIconBorderColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.border.color'
        }, 
        valueAxisValueAxisItemNotesIconBorderWidth: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.border.width'
        }, 
        valueAxisValueAxisItemNotesIconSize: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.size'
        }, 
        valueAxisValueAxisItemNotesIconType: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.type'
        }, 
        valueAxisValueAxisItemNotesIconVisible: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.notes.icon.visible'
        }, 
        valueAxisValueAxisItemNotesLabelBackground: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.notes.label.background'
        }, 
        valueAxisValueAxisItemNotesLabelBorderColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.notes.label.border.color'
        }, 
        valueAxisValueAxisItemNotesLabelBorderDashType: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.notes.label.border.dashType'
        }, 
        valueAxisValueAxisItemNotesLabelBorderWidth: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.notes.label.border.width'
        }, 
        valueAxisValueAxisItemNotesLabelColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.notes.label.color'
        }, 
        valueAxisValueAxisItemNotesLabelFont: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.notes.label.font'
        }, 
        valueAxisValueAxisItemNotesLabelTemplate: {
            type: String | Function,
            kComposite: 'valueAxis.valueAxisItem.notes.label.template'
        }, 
        valueAxisValueAxisItemNotesLabelVisible: {
            type: Boolean,
            kComposite: 'valueAxis.valueAxisItem.notes.label.visible'
        }, 
        valueAxisValueAxisItemNotesLabelRotation: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.notes.label.rotation'
        }, 
        valueAxisValueAxisItemNotesLabelFormat: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.notes.label.format'
        }, 
        valueAxisValueAxisItemNotesLabelPosition: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.notes.label.position'
        }, 
        valueAxisValueAxisItemNotesLineWidth: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.notes.line.width'
        }, 
        valueAxisValueAxisItemNotesLineColor: {
            type: String,
            kComposite: 'valueAxis.valueAxisItem.notes.line.color'
        }, 
        valueAxisValueAxisItemNotesLineLength: {
            type: Number,
            kComposite: 'valueAxis.valueAxisItem.notes.line.length'
        }, 
        valueAxisValueAxisItemNotesData: {
            type: Array,
            kComposite: 'valueAxis.valueAxisItem.notes.data'
        }    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/ValueAxis.js